<template>
  <div class="maskBox">
    <div class="topWinner" :style="{'backgroundImage':'url('+require('../../assets/images/cashWheel/topWinnerBg.webp')+')'}">
      <div class="title">{{replaceWinNum($t('lang.cashWheel.successfullyTotal'))}}</div>
      <div :class="lang==='EN'?'won':'wonIN'">{{$t('lang.cashWheel.won')}}</div>
      <div class="bubbleLanguage">{{$t('lang.cashWheel.bubbleLanguage')}}</div>
      <div class="titleBar">{{$t('lang.cashWheel.topWinner')}}</div>
      <img class="userIcon" :src="randomUser?randomUser.userImg:''" alt="">
      <img class="userIcon2" :src="randomUser?randomUser.userImg:''" alt="">
      <div class="tryBtn" @click="goTry()">{{$t('lang.cashWheel.try')}}</div>
    </div>
  </div>
</template>

<script>
import { userDataList } from './userData'
export default {
  name: 'modal-topWinner',
  data () {
    return {
      randomUser: null,
      userDataList: userDataList,
      lang: localStorage.getItem('locale')
    }
  },
  mounted () {
    this.getRandomUser()
  },
  watch: {
    '$store.state.locale': function (val) {
      this.lang = val
    }
  },
  methods: {
    getRandomUser () {
      const randomIndex = Math.floor(Math.random() * this.userDataList.length)
      this.randomUser = this.userDataList[randomIndex]
    },
    replaceWinNum (val) {
      return val.replace('{WinNum}', this.getRandomNumber(1200, 2000))
    },
    getRandomNumber (min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min
    },
    goTry () {
      this.$emit('closeMoadlTopWinner')
    }
  }
}
</script>

<style lang="less" scoped>
@keyframes expandBox {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
.maskBox{
  height: 100vh;
  width: 100%;
  position: fixed;
  background-color: rgba(0,0,0,0.8);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
}
.topWinner{
  background-size: 100% 100%;
  height: 112.77vw;
  width: 93.33vw;
  position: relative;
  top: 20vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  transform-origin: center;
  animation: expandBox 0.2s ease-in-out forwards;
  .title{
    width: 77.77vw;
    height: 15vw;
    font-size: 5.27vw;
    color: #fff;
    font-weight: 700;
    position: absolute;
    top: -18vw;
    left: 7vw;
    text-align: center;
    line-height: 7vw;
  }
  .won{
    position: absolute;
    color: #FFFFFF;
    font-size: 5.277vw;
    font-weight: 700;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
    top: 58vw;
    left: 31vw;
  }
  .wonIN{
    position: absolute;
    color: #FFFFFF;
    font-size: 5.277vw;
    font-weight: 700;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
    top: 57.5vw;
    left: 28vw;
  }
  .bubbleLanguage{
    position: absolute;
    top: 72vw;
    left: 26vw;
    color: #C5C5C5;
    font-size: 3.285vw;
    width: 55.38vw;
    height: 10vw;
    line-height: 5vw;
  }
  .titleBar{
    font-size: 4.72vw;
    color: #000;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 64.83vw;
    height: 9.28vw;
    position: relative;
    top: 5.5vw;
  }
  @keyframes shrinkAndDrop {
    0% {
      width: 200vw; /* 初始宽度特别大 */
      height: 200vw; /* 初始高度特别大 */
      top: 0; /* 初始位置 */
      opacity: 0; /* 初始不透明度为0 */
    }
    50% {
      opacity: 1; /* 中间阶段完全可见 */
    }
    100% {
      height: 21.4vw;
      width: 21.4vw;
      top: 30vw; /* 最终位置 */
      opacity: 1; /* 完全不透明 */
    }
  }
  @keyframes shrinkAndDrop2 {
    0% {
      height: 13.61vw;
      width: 13.61vw;
      left: -20vw;
      top: 70vw;
    }
    100% {
      height: 13.61vw;
      width: 13.61vw;
      top: 70vw; /* 最终位置 */
      left: 6vw;
      opacity: 1; /* 完全不透明 */
    }
  }
  .userIcon2{
    position: absolute;
    border-radius: 15vw;
    //top: -14vw;
    animation-name: shrinkAndDrop2;
    animation-duration: 0.3s;
    animation-timing-function: ease-out;
    animation-fill-mode: forwards;
    left: 0;
  }
  .userIcon{
    height: 21.4vw;
    width: 21.4vw;
    position: absolute;
    border-radius: 15vw;
    //top: -14vw;
    animation-name: shrinkAndDrop;
    animation-duration: 0.4s;
    animation-timing-function: ease-out;
    animation-fill-mode: forwards;
  }
  .tryBtn{
    height: 10.83vw;
    width: 81.913vw;
    border-radius: 2.22vw;
    background-color: #FFD84D;
    color: #000;
    font-weight: 700;
    font-size: 4.44vw;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    top: -10vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/cashWheel/modal-topWinner.vue